import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Topbar from "../components/Topbar";

const Favorite = () => {
  return (
    <>
      {/* <Topbar /> */}

      <Navbar />

      <div className="py-16 px-4 md:px-16 lg:px-24">
        {/* Title */}
        <div className="flex justify-center py-8">
          <h1 className="font-syne text-3xl md:text-5xl font-bold">Cart</h1>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Favorite;
